module.exports = __webpack_public_path__ + "static/media/happy-parent-baner-second.dbda6b22.png";